// Ian - 2026-10-13 - Fabric calculator figures and maths, in one place.
// Used by sections/ian-fabric-calculator.liquid (the calculator page) and
// snippets/ian-fabric-calc-pdp.liquid (the product page estimator and quantities table),
// so the page and the product pages can never disagree. Change a figure here and both follow.
// The calculator page also carries a static copy of the reference table for crawlers:
// regenerate it after changing G (see the comment above #fc-ref in the section).
window.CMFabricCalc = (function () {
const SHOP="/collections/";
const F={
  lawn:["Cotton lawn","cotton-lawn-dressmaking-fabric"], poplin:["Cotton poplin","cotton-poplin-fabric"],
  challis:["Viscose challis","viscose-challis-fabrics"], linen:["Linen","linen"], gauze:["Double gauze","double-gauze"],
  crepe:["Crepe","crepe-dress-fabrics"], shirting:["Shirting","cotton-shirting-and-dressmaking-fabrics"],
  chambray:["Chambray","chambray-fabric"], denim:["Denim","denim-fabric"], jersey:["Jersey","jersey-fabrics"],
  cjersey:["Cotton jersey","cotton-jersey-material"], vjersey:["Viscose jersey","viscose-jersey-fabric"],
  suiting:["Wool suiting","wool-suiting-fabric"], coating:["Wool coating","wool-coating-jacketing-fabric"],
  tweed:["Tweed","tweed-dressmaking-fabrics"], brushed:["Brushed cotton","brushed-cotton-fabrics-winceyette-flannel-fabric"],
  gingham:["Gingham","gingham-fabrics"]
};
const N={
  thread:["Thread to match","buy-sewing-thread-online-at-croft-mill-uk"],
  interfacing:["Interfacing","interfacing-fabric-dressmaking-sewing"],
  buttons:["Buttons","buttons-haberdashery-dress-sewing-accessories"],
  elastic:["Elastic","elastic-threads-cords-sewing-craft-essentials"],
  bias:["Bias binding","bias-binding-cotton-polycotton-satin-bias-binding"],
  fasteners:["Fastenings","fasteners-dressmaking-sewing-snaps-clasps-toggles"]
};
const CATS=[["tops","Tops"],["dresses","Dresses"],["skirts","Skirts"],["trousers","Trousers"],["outer","Jackets & coats"],["sleep","Nightwear"],["kids","Children"]];
// Ian: b = metres at size M (UK 12-14) or age 5-7, at [112cm, 150cm] wide. L = main pieces cut lengthwise (used for height and repeat).
const G=[
 {id:"tee",cat:"tops",name:"T-shirt",b:[1.5,1.2],L:2,desc:"Short sleeves, hip length. Most jerseys are 150cm wide.",fab:["cjersey","vjersey","jersey"],no:["thread"]},
 {id:"lstop",cat:"tops",name:"Long-sleeve top",b:[2.0,1.5],L:2,desc:"A simple pull-on top or sweatshirt with full-length sleeves.",fab:["cjersey","jersey","brushed"],no:["thread"]},
 {id:"blouse",cat:"tops",name:"Blouse",b:[2.0,1.5],L:3,desc:"Short or three-quarter sleeves, with a facing or simple collar.",fab:["lawn","challis","gauze","crepe"],no:["thread","interfacing","buttons"]},
 {id:"shirt",cat:"tops",name:"Collared shirt",b:[2.6,1.8],L:3,desc:"Long sleeves with cuffs, collar stand and a button placket.",fab:["shirting","poplin","chambray","linen"],no:["thread","interfacing","buttons"]},
 {id:"shift",cat:"dresses",name:"Simple dress",b:[2.8,2.1],L:3,desc:"Knee length with short sleeves, like a shift or skater dress.",fab:["poplin","lawn","challis","linen"],no:["thread","interfacing","fasteners"]},
 {id:"wrap",cat:"dresses",name:"Wrap or shirt dress",b:[3.2,2.4],L:3,desc:"Knee to midi length, with sleeves, ties or a button front.",fab:["challis","crepe","shirting","vjersey"],no:["thread","interfacing","buttons"]},
 {id:"maxi",cat:"dresses",name:"Maxi dress",b:[4.0,3.0],L:3,desc:"Full length with sleeves, tiers or a gathered skirt.",fab:["challis","lawn","gauze","crepe"],no:["thread","interfacing","fasteners"]},
 {id:"pencil",cat:"skirts",name:"Straight skirt",b:[1.4,1.0],L:2,desc:"A pencil or straight skirt to the knee, with a waistband.",fab:["denim","suiting","tweed","linen"],no:["thread","interfacing","fasteners"]},
 {id:"aline",cat:"skirts",name:"A-line skirt",b:[1.8,1.4],L:2,desc:"Gently flared, knee length, with a waistband or facing.",fab:["denim","chambray","poplin","linen"],no:["thread","interfacing","fasteners"]},
 {id:"gathered",cat:"skirts",name:"Gathered midi skirt",b:[2.6,2.0],L:3,desc:"Full, gathered at the waist, to mid calf.",fab:["lawn","challis","poplin","gingham"],no:["thread","elastic"]},
 {id:"circle",cat:"skirts",name:"Circle skirt",b:[2.8,1.8],L:2,desc:"A full circle to the knee. Wide fabric makes a big difference here.",fab:["crepe","poplin","challis","suiting"],no:["thread","interfacing","fasteners"]},
 {id:"shorts",cat:"trousers",name:"Shorts",b:[1.3,1.0],L:2,desc:"Above the knee, with pockets and a waistband.",fab:["chambray","linen","denim","poplin"],no:["thread","interfacing","fasteners"]},
 {id:"trousers",cat:"trousers",name:"Straight trousers",b:[2.6,1.8],L:2,desc:"Full length with pockets and a fitted waist.",fab:["suiting","denim","linen","tweed"],no:["thread","interfacing","fasteners"]},
 {id:"wide",cat:"trousers",name:"Wide-leg trousers",b:[3.0,2.3],L:2,desc:"Wide legs or culottes, full or cropped length.",fab:["linen","challis","crepe","suiting"],no:["thread","interfacing","elastic"]},
 {id:"jumpsuit",cat:"trousers",name:"Jumpsuit",b:[3.8,2.9],L:3,desc:"Full length, with sleeves or straps.",fab:["linen","challis","denim","crepe"],no:["thread","interfacing","buttons"]},
 {id:"jacket",cat:"outer",name:"Unlined jacket",b:[3.0,2.3],L:3,desc:"A chore coat, shacket or boxy jacket to the hip.",fab:["denim","tweed","suiting","linen"],no:["thread","interfacing","buttons"]},
 {id:"coat",cat:"outer",name:"Knee-length coat",b:[3.8,3.0],L:3,desc:"Collar, pockets and facings. Buy lining separately.",fab:["coating","tweed","suiting"],no:["thread","interfacing","buttons"]},
 {id:"pjs",cat:"sleep",name:"Pyjama set",b:[3.6,2.7],L:4,desc:"Long-sleeve top and full-length bottoms.",fab:["brushed","poplin","lawn","gingham"],no:["thread","elastic","buttons"]},
 {id:"shortpjs",cat:"sleep",name:"Short pyjamas",b:[2.4,1.8],L:4,desc:"Short-sleeve top and shorts, a summer set.",fab:["lawn","poplin","gauze","challis"],no:["thread","elastic","bias"]},
 {id:"kdress",cat:"kids",name:"Child's dress",b:[1.4,1.0],L:2,desc:"Knee length with short sleeves or a pinafore.",fab:["poplin","gingham","lawn","cjersey"],no:["thread","buttons"]},
 {id:"ktop",cat:"kids",name:"Child's top",b:[0.9,0.7],L:2,desc:"A T-shirt or simple blouse.",fab:["cjersey","poplin","lawn"],no:["thread"]},
 {id:"ktrousers",cat:"kids",name:"Child's trousers",b:[1.1,0.8],L:2,desc:"Elasticated full-length trousers or joggers.",fab:["cjersey","denim","brushed","chambray"],no:["thread","elastic"]}
];
const SIZES=[["XS","UK 6-8",.9],["S","UK 10",.95],["M","UK 12-14",1],["L","UK 16-18",1.1],["XL","UK 20-22",1.2],["2XL","UK 24-26",1.3],["3XL","UK 28-30",1.4]];
const KSIZES=[["2-4","age",.75],["5-7","age",1],["8-10","age",1.25],["11-13","age",1.45]];
const HEIGHTS=[["petite","Under 5'3\"",-0.05],["avg","5'3\" to 5'8\"",0],["tall","Over 5'8\"",0.08]];
const WIDTHS=[[112,'44"'],[140,'55"'],[150,'59"'],["other","Other"]];
const FIBRES=[["cotton","Cotton",.04],["linen","Linen",.06],["viscose","Viscose",.05],["jersey","Cotton jersey",.05],["wool","Wool",.02],["synth","Polyester",0],["unsure","Not sure",.05]];
const PATS=[["plain","Plain",0,"Solid or all-over"],["nap","One-way",.10,"Prints, velvet, cord"],["stripe","Stripes",.15,"Small checks too"],["check","Big checks",.25,"Plaids, large prints"]];
const SPARES=[[0,"None"],[.05,"5%"],[.10,"10%"]];

function baseAt(w,b){
  if(w<=112)return b[0]*112/w;
  if(w>=150)return b[1]*150/w;
  return b[0]+(b[1]-b[0])*(w-112)/38;
}
function calc(g,st){
  const kids=g.cat==="kids";
  const w=st.w==="other"?Math.min(180,Math.max(80,+st.cw||130)):+st.w;
  const base=baseAt(w,g.b);
  const sf=kids?KSIZES.find(s=>s[0]===st.ksize)[2]:SIZES.find(s=>s[0]===st.size)[2];
  let sized=base*sf;
  // Ian: on narrow fabric, larger sizes stop fitting pieces side by side
  const narrowJump=(!kids&&w<125&&sf>=1.2)?sized*.10:0;
  sized+=narrowJump;
  const hAdj=kids?0:HEIGHTS.find(h=>h[0]===st.h)[2]*g.L;
  const make=Math.max(.3,sized+hAdj);
  const p=PATS.find(x=>x[0]===st.pat);
  let pat=make*p[2];
  if(st.pat!=="plain"&&+st.rep>0)pat=Math.max(pat,(+st.rep/100)*g.L);
  const fib=FIBRES.find(f=>f[0]===st.fib);
  const shrPct=st.pre?fib[2]:0;
  const shr=(make+pat)*shrPct;
  const spare=(make+pat+shr)*st.spare;
  const raw=make+pat+shr+spare;
  const buy=Math.ceil(raw*2-1e-9)/2;
  return {w,base,sf,narrowJump,hAdj,make,pat,shr,shrPct,spare,raw,buy,fib,p};
}
const fmt=v=>(v%1===0?v.toFixed(0):v.toFixed(1));
const REF_STATE={size:"M",ksize:"5-7",h:"avg",fib:"cotton",pre:true,pat:"plain",rep:0,spare:.05};
function refRows(){
  let html="";
  CATS.forEach(([c,l])=>{
    html+='<tr class="grp"><th colspan="4">'+l+'</th></tr>';
    G.filter(g=>g.cat===c).forEach(g=>{
      html+='<tr><td>'+g.name+'</td>'+[112,140,150].map(w=>'<td class="m">'+fmt(calc(g,Object.assign({w},REF_STATE)).buy)+'m</td>').join("")+'</tr>';
    });
  });
  return html;
}

// Ian: maps a product's custom.good_for words to the makes above, for the product page table.
// Each word is lower-cased with punctuation turned into spaces and padded with spaces, so
// " dresses " matches but "dressmaking" doesn't, and "T-shirts" becomes " t shirts ".
const GOOD_FOR = [
  [/ t shirts? | sweatshirts? | hoodies? | jumpers? | sweaters? /, ["tee","lstop"]],
  [/ dress(es)? /, ["shift","wrap","maxi"]],
  [/ skirts? /, ["aline","gathered"]],
  [/ blouses? | tops? | tunics? /, ["blouse"]],
  [/ (over)?shirts? /, ["shirt"]],
  [/ trousers? | pants | palazzo | jeans /, ["trousers","wide"]],
  [/ shorts /, ["shorts"]],
  [/ jumpsuits? | dungarees? /, ["jumpsuit"]],
  [/ jackets? | blazers? /, ["jacket"]],
  [/ coats? /, ["coat"]],
  [/ pyjamas? | loungewear | nightwear /, ["pjs"]],
  [/ child/, ["kdress","ktop"]]
];
function makesFor(words, max) {
  const out = [];
  (words || []).forEach(function (w) {
    const t = " " + String(w).toLowerCase().replace(/[^a-z]+/g, " ").trim() + " ";
    GOOD_FOR.forEach(function (r) {
      // "T-shirts" also contains " shirts ", which is a different make.
      if (r[1][0] === "shirt" && / t shirts? /.test(t)) return;
      if (r[0].test(t)) r[1].forEach(function (id) { if (out.indexOf(id) < 0) out.push(id); });
    });
  });
  return out.slice(0, max || 6);
}
// Ian: the first make for each kind of garment a product is good for (dress, skirt, shirt...),
// for the estimator's short list of choices under the quantity box.
function groupsFor(words, max) {
  const out = [];
  (words || []).forEach(function (w) {
    const t = " " + String(w).toLowerCase().replace(/[^a-z]+/g, " ").trim() + " ";
    GOOD_FOR.forEach(function (r) {
      if (r[1][0] === "shirt" && / t shirts? /.test(t)) return;
      if (r[0].test(t) && out.indexOf(r[1][0]) < 0) out.push(r[1][0]);
    });
  });
  return out.slice(0, max || 4);
}
// Ian: works out the matching allowance from what the store already records about a fabric:
// the product.pattern_theme metafield (the one behind the Shop by Pattern pages) and words in
// the product title. Returns the calculator's pattern key, whether it's a print (so the shopper
// can say if it runs one way), and a short reason to show next to the result.
// Nothing records whether a print is one-way or how big its repeat is, so prints aren't guessed.
function patternFor(themes, title) {
  const th = (themes || []).join(" ").toLowerCase();
  const t = " " + String(title || "").toLowerCase().replace(/[^a-z0-9]+/g, " ") + " ";
  const small = / gingham | micro | mini | 1 8 | 1 4 | small /.test(t);
  if (/ velvet| velour| corduroy| needlecord| cord | faux fur| moleskin| suedette/.test(t))
    return { pat: "nap", print: false, why: "Includes 10% because the pile runs one way" };
  if (th.indexOf("check") > -1 || / gingham | check| tartan| plaid| houndstooth| dogtooth/.test(t))
    return small
      ? { pat: "stripe", print: false, why: "Includes 15% for matching the checks" }
      : { pat: "check", print: false, why: "Includes 25% for matching the checks" };
  if (th.indexOf("stripe") > -1 || / stripe| ticking| pinstripe/.test(t))
    return { pat: "stripe", print: false, why: "Includes 15% for matching the stripes" };
  if (th && th.indexOf("plain") < 0)
    return { pat: "plain", print: true, why: "" };
  return { pat: "plain", print: false, why: "" };
}
return {SHOP:SHOP,F:F,N:N,CATS:CATS,G:G,SIZES:SIZES,KSIZES:KSIZES,HEIGHTS:HEIGHTS,WIDTHS:WIDTHS,FIBRES:FIBRES,PATS:PATS,SPARES:SPARES,
  baseAt:baseAt,calc:calc,fmt:fmt,REF_STATE:REF_STATE,refRows:refRows,makesFor:makesFor,groupsFor:groupsFor,patternFor:patternFor};
})();
